import { render, staticRenderFns } from "./MenuTabList.vue?vue&type=template&id=f2b33bc6&scoped=true&"
import script from "./MenuTabList.vue?vue&type=script&lang=js&"
export * from "./MenuTabList.vue?vue&type=script&lang=js&"
import style0 from "./MenuTabList.vue?vue&type=style&index=0&id=f2b33bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b33bc6",
  null
  
)

export default component.exports